import TrustMark from 'components/ProductPage/RatingsAndReviews/TrustMark/TrustMark';
import { withTrustMarkProps } from 'viewModel/product/ratingsAndReviews/trustMark/withTrustMarkProps';

export default withTrustMarkProps(TrustMark);
